import { render, staticRenderFns } from "./ProfitandLoss.vue?vue&type=template&id=0f88b261&scoped=true"
import script from "./ProfitandLoss.vue?vue&type=script&lang=js"
export * from "./ProfitandLoss.vue?vue&type=script&lang=js"
import style0 from "./ProfitandLoss.vue?vue&type=style&index=0&id=0f88b261&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88b261",
  null
  
)

export default component.exports